var Store = require("./Store");
var xmlToJson = require("./xmlToJson")

/**
 * @class
 */
function Authenticator(sRootUrl) {
  var self = this;

  self.apiEndpoint = '/qless/authenticator';
  self.authEndpoint = '/qless/api/v1/employee/authInfo';
  self.locs = {
    cecLoc: '/cec',
    monLoc: '/monitor',
    kioskLoc: '/kiosk/app/location'

  },
    self.rootUrl = sRootUrl || '../';
  self.store = new Store();



	/**
	 * Dispatches a custom event
	 *
	 * @method broadcastError
	 * @param {String} sType Type of error event
	 * @returns none
	 */
  self.broadcastError = function (sType) {
    var errorEvent = new Event(sType + 'Error');

    document.dispatchEvent(errorEvent);
  };

	/**
	 * Inspects the browser for authorization cookies
	 *
	 * @method checkLogin
	 * @param [Function] fCallback
	 * @returns none
	 */
  self.checkLogin = function (fCallback) {
    if (self.getAUCookies()) {
      fCallback();
    }
    else {
      self.logout();
    }
  };


	/**
	 * Hack-ish way of forwarding a user to the app based on
	 * - strings found in the user name OR
	 * - the document.referrer OR
	 * - CEC
	 *
	 * @method forwardUserToApp
	 * @param {XMLDocument} data
	 * @returns none
	 */
  self.forwardUserToApp = function (data) {
    var loc = self.locs.cecLoc;
    var json = xmlToJson.parse(data);
    var authinfo = json.authInfo;
    var userid = null;

    // Make sure there was an authInfo node
    if (authinfo) {
      userid = authinfo.userid;

      // Make sure there was a userid attribute
      if (userid) {
        // Transform the username to a lower case for comparison
        userid = userid.toLowerCase();

        if (userid.indexOf('monitor') > -1) {
          loc = self.locs.monLoc;
        }
        else if (userid.indexOf('kiosk') > -1) {
          loc = self.locs.kioskLoc;
        }

        // Send the user to the best known app location
        document.location.href = loc;
        return;
      }
    }

    // If we got here, we failed to forward the user
    self.broadcastError('forwarding');
  };


	/**
	 * Looks through cookies found and returns any AU cookies
	 *
	 * @method getAUCookies
	 * @returns {Array | Null}
	 */
  self.getAUCookies = function () {
    var arr = [],
      cookies = document.cookie.split(';');

    if (cookies) {
      cookies.forEach(function (cookie) {
        var parts = cookie.trim().split('=');

        if (parts[0].indexOf('au') === 0) {
          arr.push({
            name: parts[0],
            value: parts[1]
          });
        }
      });
    }

    return (arr.length > 0) ? arr : null;
  };


	/**
	 * Calls the authInfo API to retrieve role information
	 *
	 * @method getAuthInfo
	 * @returns none
	 */
  self.getAuthInfo = function () {
    $.ajax({
      method: 'GET',
      url: self.authEndpoint,
      success: function (data) {
        if (data) {
          self.forwardUserToApp(data);
        }
        else {
          // Broadcast event so UI can respond.
          self.broadcastError('login');
        }
      }
    });
  };

	/**
	 * Redirects the user to the login page
	 *
	 * @method gotoLogin
	 * @returns none
	 */
  self.gotoLogin = function () {
    document.location.replace('/login');
  };


	/**
	 * Reads paths from a json file
	 *
	 * @method loadPaths
	 * @param {String} sJsonPath Path to file to load
	 * @returns none
	 */
  self.loadPaths = function (sJsonPath) {
    // Only process if a path was specified
    if (sJsonPath) {
      $.ajax({
        method: 'GET',
        url: sJsonPath,
        dataType: 'json',
        // If data was returned and it looks like a JSON object
        // replace known paths with that data
        success: function (data) {
          if (typeof data === 'object') {
            self.locs = data;
          }
        }
      });
    }
  };


	/**
	 * Passes authentication information to the API service
	 *
	 * @method login
	 * @param sPrincipal
	 * @param
	 * @returns
	 */
  self.login = function (sPrincipal, sCredentials) {
    // Remove any outstanding auth or identity cookies
    self.removeLoginCookies();

    // Request data from the API
    $.ajax({
      method: 'POST',
      url: self.apiEndpoint,
      data: {
        principal: sPrincipal,
        credentials: sCredentials,
        remember: true
      },
      success: function (data) {
        // If auth cookies are found, process them to figure out
        // where to send the user to attempt to get them to the
        // correct application
        if (self.getAUCookies()) {
          self.getAuthInfo();
        }
        // Broadcast the error event so UI can respond.
        else {
          self.broadcastError('login');
        }
      },
      error: function () {
        self.broadcastError('connection');
      }
    });
  };


	/**
	 * Removes credentials for the user and redirects them to the login page
	 *
	 * @method logout
	 * @returns none
	 */
  self.logout = function () {
    self.removeLoginCookies();

    self.gotoLogin();
  };


	/**
	 * Clears any existing login cookies
	 *
	 * @method removeLoginCookies\
	 * @returns none
	 */
  self.removeLoginCookies = function () {
    // Get authorization cookies
    var cookies = self.getAUCookies();

    // If any auth cookies were found, remove them
    if (cookies) {
      cookies.forEach(function (cookie) {
        self.store.del(cookie.name);
      });
    }

    // Remove the identity cookie
    self.store.del('i');
  };

  return self;
};


module.exports = Authenticator;
